module.exports = __webpack_public_path__ + "img/instructor_img3.6e8bf5a1.png";